/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2022
 * @flow
 */

import React from 'react';
import Body from '../../components/Body';
import Popup from '../../../../components/Popup/Popup';
import PopupContent from '../../../../components/Popup/PopupContent';
import classes from './Desktop.module.css';
import StockStatusConfirmationPopup from '../../components/StockStatusConfPopup';

const Desktop = props => {
  const {
    popup,
    itemToBeUpdated,
    closePopup,
    invokeItemStatusUpdateApi,
  } = props;

  const getPopupContent = () => {
    if (!popup) return;
    switch (popup.type) {
      case 'updateStockStatus':
        return (
          <StockStatusConfirmationPopup
            stocked={itemToBeUpdated.stocked}
            onCancel={closePopup}
            onProceed={invokeItemStatusUpdateApi}
          />
        );
      default: {
        return <PopupContent {...popup} />;
      }
    }
  };

  const getPopupStyle = () => {
    let popupStyle = { width: '31.25vw' };
    if (popup && popup.type === 'spinner') {
      popupStyle = { width: '50%' };
    } else if (popup && popup.type === 'updateStockStatus') {
      popupStyle = { width: '35%' };
    }
    return popupStyle;
  };

  return (
    <div className={classes.container}>
      <Popup visible={!!popup} popupStyle={getPopupStyle()}>
        {getPopupContent()}
      </Popup>
      <Body {...props} />
    </div>
  );
};

export default Desktop;
